import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
    standalone: false,
})
export class SectionComponent {

    @Input()
    public header: string = '';
}
